import React from "react";
import type { PresenceUser } from "../../Realtime/RealtimeProvider";
import { avatarHue, userInitials } from "./dashboardShared";

export interface IdentityStripProps {
	userName: string;
	connected: boolean;
	online: number;
	users: PresenceUser[];
}

const todayLabel = (): string => {
	try {
		const s = new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(new Date());
		return s.charAt(0).toUpperCase() + s.slice(1);
	} catch {
		return "";
	}
};

/** Slim greeting line: who you are, the date, and who else is on. Plain text, not a panel. */
export const IdentityStrip: React.FC<IdentityStripProps> = ({ userName, connected, online, users }) => {
	const ordered = [...users].sort((a, b) => (a.user === userName ? -1 : b.user === userName ? 1 : 0));
	const shown = ordered.slice(0, 4);

	return (
		<div className="flex flex-wrap items-center justify-between gap-3 px-0.5">
			<div className="min-w-0">
				<h1 className="truncate text-xl font-bold text-slate-900">Bonjour, {userName}</h1>
				<p className="text-sm text-slate-500">{todayLabel()}</p>
			</div>

			<div className="flex items-center gap-2.5">
				{shown.length > 0 && (
					<div className="flex -space-x-2">
						{shown.map((u, i) => (
							<span
								key={`${u.user}-${i}`}
								title={u.user}
								className={`flex h-7 w-7 items-center justify-center rounded-full border-2 border-white text-[10px] font-bold ${
									u.user === userName ? "ring-1 ring-sky-400" : ""
								} ${avatarHue(u.user)}`}
							>
								{userInitials(u.user)}
							</span>
						))}
					</div>
				)}
				<span className="inline-flex items-center gap-1.5 text-sm text-slate-500">
					<span className={`h-2 w-2 rounded-full ${connected ? "bg-emerald-500" : "bg-slate-300"}`} aria-hidden />
					{connected ? `${online} en ligne` : "Hors ligne"}
				</span>
			</div>
		</div>
	);
};

export default IdentityStrip;
